import { isCustomProduct, state } from '../../store/state';
import { frameColorsVNode } from './frameColorsVNode';
import { isNullOrUndef } from '../../../../js/helpers/isNullOrUndef';
import { isNotNullOrUndef } from '../../../../js/helpers/isNotNullOrUndef';
import { frameColorsForRender } from './frameColorsForRender';
import triggers from '../../store/triggers';
const vNode = window.vNode;
const containerSelector = isCustomProduct ? '#optionsWrapper' : '#v2_optionsWrapper';
const container = document.querySelector(containerSelector);
let framesVNode;
export const frameColor = () => {
    if (isNullOrUndef(container))
        return;
    const layout = state.layout ?? '';
    const layoutLow = (layout.includes(' - ') ? layout.substring(layout.indexOf('-') + 2) : layout).toLowerCase();
    const isFramed = layoutLow.includes('framed');
    if (!isFramed) {
        isNotNullOrUndef(framesVNode) && vNode.unmount(framesVNode);
        framesVNode = null;
        return;
    }
    const layoutColors = frameColorsForRender[layoutLow];
    if (state.frameColor === '' || !layoutColors.some(({ name }) => name === state.frameColor)) {
        state.frameColor = layoutColors[0].name;
        triggers.emitEvent('state:frameColor', [layoutColors[0].name]);
    }
    const newVNode = frameColorsVNode(layoutLow);
    vNode.patch(framesVNode, newVNode, container);
    framesVNode = newVNode;
};
